export const theme = {
  bg: '#0c0c0c',
  surface: '#161618',
  surfaceElevated: '#1e1e21',
  accent: '#ff4500',
  accentHover: '#e63e00',
  accentSubtle: 'rgba(255, 69, 0, 0.12)',
  text: '#f0f0f0',
  textMuted: '#777',
  textDim: '#444',
  border: '#242428',
  borderSubtle: '#1c1c20',
  success: '#22c55e',
  successSubtle: 'rgba(34, 197, 94, 0.12)',
} as const
